import { humanize } from '@utils';
import moment from 'moment-timezone';
import { message } from 'antd';

export const metricShortMap = {
  VideoStartFailuresTechPercentage: 'VSF-T',
  HighExitBeforeVideoStartPercentage: 'Abandonment',
  ConnectionInducedRebufferingRatio: 'CIRR',
  ExitBeforeVideoStartsPercentage: 'EBVS',
  TotalImpactedSessions: 'SESSIONS',
  VideoPlaybackFailuresTechPercentage: 'VPF-T',
};

export const formatName = (data: any) => {
  return data;
};

export const formatRootCause = (metric: string) => {
  // Default first rootcause to be always used
  const highMetric = metric[0];
  return metricShortMap[highMetric];
};

export const formatRootCauseValue = (metric: string, list: any) => {
  const highMetricValue = metric[0];
  return humanize(list[highMetricValue], '');
};

export const formatSessions = (list) => {
  // Impacted Sessions need to always shown
  const totalSessions = 'TotalImpactedSessions';
  return humanize(list[totalSessions], '');
};

export const formatImpactedUnique = (list) => {
  // Impacted Unique to be formatted
  const totalSessions = 'ImpactedUniqueDevices';
  if (!list[totalSessions]) {
    return 'NA';
  }
  return humanize(list[totalSessions], '');
};

export const formatInterval = (value: any) => {
  try {
    if (value && value.length > 0) {
      const customerTimeZone = moment().format('z');
      // Check if IST timezone, reduce time by 30 mins bucket
      if (customerTimeZone === 'IST') {
        return moment(value).subtract(30, 'minutes').format();
      }
      return moment(value).format();
    }
  } catch (err) {
    const errorMsg = 'Unknown error!';
    message.error(errorMsg);
  }
  return true;
};
